import { Grid } from '@interstate/components/Grid';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import { useMediaQuery } from 'react-responsive';
import { BreakPoint } from '@makemydeal/dr-activities-common';

import DealSummaryItem from '../../common/DealSummaryItem';
import LineItemWithChildren from '../../common/LineItemWithChildren';
import AcvLineItem from './AcvLineItem';
import { useTrades, type TradeInItemWithIndex } from './useTrades';
import {
    expandibleButtonStyles,
    expandibleAreaStyles,
    detailedViewLabelStyles,
    secondaryValueStyles,
    detailedViewValueStyles,
    detailedViewGridProps,
    defaultGridProps
} from '../../utils/styles';
import * as constants from '../../../constants';

const TradesDetailedView = () => {
    const { tradeIns } = useTrades();
    const isLargeSize = useMediaQuery({ query: `(min-width: ${BreakPoint.MEDIUM})` });

    const gridProps = isLargeSize ? detailedViewGridProps : defaultGridProps;
    const activeTradeIns = tradeIns.filter(({ isDeleted }) => !isDeleted);

    if (activeTradeIns.length === 0) {
        return null;
    }

    return (
        <DealSummaryItem label="Trades" value="" valueStyles={detailedViewValueStyles}>
            <Grid sx={gridProps}>
                {activeTradeIns.map(({ tradeIn, originalIndex }: TradeInItemWithIndex) => {
                    const vehicleDetails = [tradeIn.year, tradeIn.make, tradeIn.model].filter(Boolean).join(' ');
                    const tradeLabel =
                        activeTradeIns.length > 1
                            ? `Trade ${originalIndex + 1}${vehicleDetails ? `: ${vehicleDetails}` : ''}`
                            : vehicleDetails || `Trade ${originalIndex + 1}`;

                    return (
                        <DealSummaryItem
                            key={`trade-${originalIndex}`}
                            expandibleButtonStyles={expandibleButtonStyles}
                            expandibleAreaStyles={expandibleAreaStyles}
                            valueStyles={secondaryValueStyles}
                            labelStyles={{ ...detailedViewLabelStyles, mr: 1, flex: 1 }}
                            label={tradeLabel}
                            value={formatDollarsAndCents((tradeIn.value || 0) - (tradeIn.amountOwed || 0))}
                        >
                            <LineItemWithChildren
                                label={constants.ALLOWANCE}
                                value={formatDollarsAndCents(tradeIn.value || 0)}
                                containerStyles={{ pr: 0 }}
                            />
                            <LineItemWithChildren
                                label={constants.PAYOFF}
                                value={formatDollarsAndCents(tradeIn.amountOwed || 0)}
                                containerStyles={{ pr: 0 }}
                            />
                            <AcvLineItem acv={tradeIn.acv || 0} originalIndex={originalIndex} />
                        </DealSummaryItem>
                    );
                })}
            </Grid>
        </DealSummaryItem>
    );
};

export default TradesDetailedView;
